import { CreateAuthHeaders, FetchGet } from '../utils/dataModel';

const convertDateToUTC = (date) => {
  const d = new Date(date);
  return d.getUTCFullYear() + '-' + 
         String(d.getUTCMonth() + 1).padStart(2, '0') + '-' + 
         String(d.getUTCDate()).padStart(2, '0');
}

/**
 * Service class for handling dashboard history data operations.
 */
class DashboardHistoryService {
  /**
   * Gets historical data within a date range.
   * @param {Date} startDate - Start date for the range
   * @param {Date} endDate - End date for the range
   * @returns {Array} Filtered history data
   */
  async getHistoryData(selectedLicense, startDate, endDate) {
    return new Promise((resolve, reject) => {
      const apiUrl = `/api/v1/dashboard/history?license_id=${selectedLicense.license_id}&from=${convertDateToUTC(startDate)}&to=${convertDateToUTC(endDate)}`;
      FetchGet(apiUrl, CreateAuthHeaders("session_id"))
        .then(data => {
          resolve(data);
        })
        .catch(error => {
          console.error('Error fetching history data:', error);
          reject(error);
        });
    });
  }
}

const history_service = new DashboardHistoryService();
export default history_service;